import * as React from "react";
export class DropdownEmbeddableList extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.hideListHandler = (e) => {
            e.stopPropagation();
            this.props.hideListHandler();
        };
    }
    componentDidMount() {
        document.addEventListener("click", this.hideListHandler, false);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.hideListHandler, false);
    }
    render() {
        return (React.createElement("div", { className: "rj-dropdown-embeddable__list" }, this.props.options.map(option => {
            const selected = option.value === this.props.selected.value ? true : false;
            return React.createElement("div", { className: "rj-dropdown-embeddable__item", onClick: this.props.makeChoice, "data-selected": selected, "data-value": option.value, key: option.value, "data-uat": `${this.props.dataUat}-item` }, option.label);
        })));
    }
}
//# sourceMappingURL=DropdownEmbeddableList.js.map